export const ASKANDY_SUPPORT_EMAIL = 'customer-care@andy-woods-ministries.odoo.com';

export const SUPPORT_ESCALATION = ` If this keeps happening, please email ${ASKANDY_SUPPORT_EMAIL}.`;

/** Append support contact unless the message already includes it. */
export function withSupportEscalation(message: string): string {
  if (message.includes(ASKANDY_SUPPORT_EMAIL)) {
    return message;
  }
  const trimmed = message.trim();
  const needsPeriod = trimmed.length > 0 && !/[.!?]$/.test(trimmed);
  return `${trimmed}${needsPeriod ? '.' : ''}${SUPPORT_ESCALATION}`;
}

export const CHAT_ERROR_MESSAGES = {
  generic:
    'Something went wrong while processing your request. Refresh the page and try sending your message again.',

  rateLimited:
    'You are sending messages too quickly. Wait 30–60 seconds, then try again.',

  requestFailed: (status: number) =>
    `We couldn't complete your request (error ${status}). Refresh the page and try again.`,

  responseBodyNull:
    "We didn't receive a complete response from the server. Refresh the page and try again.",

  streamTimedOut:
    'The response took too long to arrive. Refresh the page and try sending your message again.',

  turnstileRequired:
    "We couldn't verify your request automatically. Refresh the page and tap Send again. If a security check appears on screen, complete it. For best results, use Chrome or Safari (not an in-app browser) and temporarily turn off ad blockers or VPN if you use them.",

  turnstileFailedExpired:
    'Your message took too long to send and the security check expired. Tap Send again right away. If your connection is slow, wait for Wi‑Fi or a stronger signal, then try once more.',

  turnstileFailed:
    "We couldn't verify your request. Refresh the page and tap Send again. If a security check appears, complete it. Try Chrome or Safari, and temporarily disable ad blockers or VPN if you use them.",

  turnstileUnavailable:
    'Security verification is temporarily unavailable. Wait a minute, refresh the page, and try again.',

  turnstileScriptLoadFailed:
    "We couldn't load our security check. Check your internet connection, refresh the page, and try again. Ad blockers or privacy extensions may block it—try allowing this site or using Chrome or Safari.",

  turnstileNotConfigured:
    "AskAndy couldn't start security verification. Refresh the page and try again.",

  turnstileUnavailableClient:
    "Security verification isn't available in your browser right now. Refresh the page or switch to Chrome or Safari, then try again.",

  turnstileTimedOut:
    'Security verification timed out—this often happens on slower connections. Wait for Wi‑Fi or a stronger signal, refresh the page, and send your message again.',

  turnstileChallengeFailed:
    "We couldn't complete the security check. Refresh the page and try again. If a check appears on screen, complete it. Ad blockers, VPNs, and in-app browsers can interfere—try Chrome or Safari without those enabled.",

  turnstilePatFailed:
    "Your browser couldn't complete Apple's automatic security check. On iPhone/iPad go to Settings → Apple Account → Sign-In & Security and turn on Automatic Verification, then disable iCloud Private Relay and any content blockers for this site and try again.",

  turnstileCancelled:
    'Security verification was cancelled. Tap Send again to continue. If a security check appears, complete it before sending.',

  /** Shown when the Cloudflare widget is Managed-only — invisible size is required for normal chat. */
  turnstileManagedWidgetMisconfigured:
    "The security check couldn't load. Refresh the page and try again in Chrome or Safari (not an in-app browser). If it still fails, temporarily turn off ad blockers, VPN, or iCloud Private Relay.",

  turnstileInAppWebView:
    "This in-app browser can't complete the security check. Tap the menu (⋯ or Open in browser) and open AskAndy in Chrome or Safari, then send your question again.",
} as const;

export function userFacingChatError(message: string): string {
  return withSupportEscalation(message);
}
